import { useEffect, useState } from "react";
import { adminApi, getToken } from "../lib/adminAuth";
import { API, formatDate } from "../lib/api";
import ConfirmModal from "./ConfirmModal";

const PER_PAGE = 20;

export default function PanelSuscriptores() {
  const [data, setData] = useState({ items: [], total: 0, activos_total: 0, historico_total: 0 });
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [confirm, setConfirm] = useState(null);
  const [toast, setToast] = useState(null);

  const load = () =>
    adminApi
      .get("/admin/newsletter", { params: { q, page, per_page: PER_PAGE } })
      .then((r) => setData(r.data));

  useEffect(() => {
    const id = setTimeout(load, 250); // debounce search
    return () => clearTimeout(id);
    // eslint-disable-next-line
  }, [q, page]);

  useEffect(() => { setPage(1); }, [q]);

  const showToast = (m, t = "ok") => { setToast({ m, t }); setTimeout(() => setToast(null), 2200); };

  const toggleActivo = async (s) => {
    await adminApi.patch(`/admin/newsletter/${s.id}`, { activo: !s.activo });
    load();
    showToast(s.activo ? "Desactivado" : "Activado");
  };

  const askDelete = (s) =>
    setConfirm({
      title: "¿Eliminar suscriptor?",
      message: `Vas a borrar definitivamente a ${s.nombre} (${s.email}). ¿Estás seguro?`,
      onConfirm: async () => {
        await adminApi.delete(`/admin/newsletter/${s.id}`);
        setConfirm(null);
        showToast("Eliminado");
        load();
      },
    });

  const exportCsv = async () => {
    // Use fetch to handle binary download
    const res = await fetch(`${API}/admin/newsletter/export`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    if (!res.ok) {
      showToast("No se pudo exportar", "error");
      return;
    }
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "suscriptores.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  const totalPages = Math.max(1, Math.ceil(data.total / PER_PAGE));

  return (
    <div data-testid="panel-suscriptores">
      <div className="panel-eyebrow">Newsletter</div>
      <h1>Suscriptores</h1>

      <div className="panel-controls" style={{ marginTop: 24 }}>
        <input
          className="search-input"
          type="search"
          placeholder="Buscar por nombre o email…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          data-testid="suscriptores-search"
        />
        <button className="btn btn-primary btn-sm" onClick={exportCsv} data-testid="suscriptores-export">
          Exportar CSV
        </button>
        <span className="panel-counters" data-testid="suscriptores-counters">
          {data.activos_total} activos / {data.historico_total} histórico
        </span>
      </div>

      <div className="panel-card">
        {data.items.length === 0 ? (
          <p style={{ color: "var(--ink-3)", padding: 20, textAlign: "center" }}>
            No hay suscriptores que coincidan.
          </p>
        ) : (
          <table className="panel-table" data-testid="suscriptores-list">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Email</th>
                <th>Fecha</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((s) => (
                <tr key={s.id} data-testid={`sub-row-${s.id}`}>
                  <td style={{ fontWeight: 500 }}>{s.nombre}</td>
                  <td style={{ fontSize: "0.86rem", color: "var(--ink-2)" }}>{s.email}</td>
                  <td style={{ fontSize: "0.86rem" }}>{formatDate(s.fecha_suscripcion)}</td>
                  <td>
                    <span className={`estado-pill ${s.activo ? "aprobado" : "eliminado"}`}>
                      {s.activo ? "activo" : "inactivo"}
                    </span>
                  </td>
                  <td>
                    <div className="panel-actions">
                      <button className="btn-tiny" onClick={() => toggleActivo(s)} data-testid={`sub-toggle-${s.id}`}>
                        {s.activo ? "Desactivar" : "Activar"}
                      </button>
                      <button className="btn-tiny danger" onClick={() => askDelete(s)} data-testid={`sub-delete-${s.id}`}>
                        Eliminar
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {totalPages > 1 && (
        <div className="pagination" data-testid="sub-pagination">
          <button disabled={page === 1} onClick={() => setPage(page - 1)}>← Anterior</button>
          <span style={{ padding: "8px 14px", fontFamily: "var(--font-display)", fontSize: "0.86rem" }}>
            {page} / {totalPages}
          </span>
          <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>Siguiente →</button>
        </div>
      )}

      {confirm && <ConfirmModal {...confirm} onCancel={() => setConfirm(null)} />}
      {toast && <div className={`toast ${toast.t === "error" ? "error" : ""}`}>{toast.m}</div>}
    </div>
  );
}
